import React from 'react';

import AccountDetails from './AccountDetails';
import CheckingCard from './CheckingCard';
import LockedManageAccount from './LockedManageAccount';
import ManageAccount from './ManageAccount';

import { Account, Card } from '../data';

export interface Props {
  card: Card;
  cardPendingVerification: Card | null;
  account: Account;
  isAccountOrCustomerLocked?: boolean;
  showOpenSpendingAccountChangeModal: boolean;
}

const Manage: React.FC<React.PropsWithChildren<Props>> = ({
  card,
  cardPendingVerification,
  account,
  isAccountOrCustomerLocked,
  showOpenSpendingAccountChangeModal,
}) => {
  return (
    <>
      <CheckingCard>
        <AccountDetails account={account} />
      </CheckingCard>
      {isAccountOrCustomerLocked ? (
        <CheckingCard>
          <LockedManageAccount />
        </CheckingCard>
      ) : (
        <CheckingCard>
          <ManageAccount
            account={account}
            card={card}
            cardPendingVerification={cardPendingVerification}
            showOpenSpendingAccountChangeModal={showOpenSpendingAccountChangeModal}
          />
        </CheckingCard>
      )}
    </>
  );
};

export default Manage;
